import { User } from '@120wateraudit/envirio-components/dist/models'
import CrudActions, { ICrudActions } from 'src/actions/helpers/CrudActions'

const actions: ICrudActions = CrudActions<User>({
  entityName: 'user',
  collectionName: 'users'
})

export default actions
